import EventEmitter from 'eventemitter3';

/**
 * Système global d'événements pour l'application.
 * Permet la communication entre composants sans dépendances directes.
 * 
 * Utilisé pour:
 * - Ouverture des modales de produits
 * - Communication entre composants
 */
class EventBusSystem {
  private emitter: EventEmitter;
  
  constructor() {
    this.emitter = new EventEmitter();
    
    if (typeof window !== 'undefined') {
      // Expose l'EventBus au niveau global pour accès depuis les scripts injectés
      (window as any).EventBus = {
        emit: this.emit.bind(this),
        on: this.on.bind(this),
        off: this.off.bind(this)
      };
    }
  }
  
  /**
   * Émet un événement avec les données spécifiées
   */
  emit(event: string, data?: any): void {
    this.emitter.emit(event, data);
  }
  
  /**
   * Abonne une fonction callback à un événement
   */
  on(event: string, callback: (data?: any) => void): void {
    this.emitter.on(event, callback);
  }
  
  /**
   * Désabonne une fonction callback d'un événement
   */
  off(event: string, callback: (data?: any) => void): void {
    this.emitter.off(event, callback);
  }
  
  /**
   * Abonne une fonction callback à un événement pour une seule occurrence
   */
  once(event: string, callback: (data?: any) => void): void {
    this.emitter.once(event, callback);
  }
}

// Création d'une instance unique de l'EventBus
export const EventBus = new EventBusSystem();

// Pour mettre à jour l'interface Window et éviter les erreurs TypeScript
declare global {
  interface Window {
    EventBus?: {
      emit: (event: string, data?: any) => void;
      on: (event: string, callback: (data?: any) => void) => void;
      off: (event: string, callback: (data?: any) => void) => void;
    };
  }
}

export default EventBus; 